import { Avatar, Group, Text } from '@mantine/core';
import Header from '../../../components/Header';
import { Pill } from '../../../components/Pill';
import { SnippetContainerBox } from '../../../components/SnippetContainer';
import { ROUTES } from '../../../routes/routes';
import { GatedSheetsConfiguration } from '../../../types/gatedContent';
import Footer from '../../PricingPages/NewPage/Footer';
import { SNIPPET_SERVER_URL } from '../../../utils/constants';
import SnippetBox from '../../../components/SnippetBox';
import ExternalLink from '../../../components/ExternalLink';

interface Props {
    gatedContent: GatedSheetsConfiguration;
}

export default function ViewSheetsSnippet({ gatedContent }: Props) {
    const standaloneWebpageUrl = `${SNIPPET_SERVER_URL}/gated/${gatedContent.id}`;
    return (
        <>
            <div className="flex flex-col w-2/3 mx-auto">
                <Header className="text-center py-8 mb-8">Your Google Sheet Has Paid Access</Header>
                <SnippetContainerBox>
                    <p className="pb-2">
                        Paying customers can now access your Google Sheet. Anyone visiting the following sheets must be
                        a paying customer.
                    </p>
                    <ul className="font-light pt-4 pb-8">
                        {gatedContent.gatedSheets.map(({ sheet }) => (
                            <li key={sheet.id} className="border rounded-xl bg-gray-50 px-4 py-2">
                                <a
                                    href={`https://docs.google.com/spreadsheets/d/${sheet.id}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:underline"
                                >
                                    <Group noWrap>
                                        <Avatar size="xs" src={sheet.iconLink} />

                                        <div>
                                            <Text>{sheet.title}</Text>
                                        </div>
                                    </Group>
                                </a>
                            </li>
                        ))}
                    </ul>

                    <p className="pb-2">
                        Send the following <ExternalLink href={standaloneWebpageUrl}>link</ExternalLink> to your
                        customers who can enter their email address and receive a direct link to the customer portal.
                    </p>
                    <SnippetBox snippet={standaloneWebpageUrl} />

                    <p className="pb-2 px-8 pt-4">
                        <div className="mb-4">
                            <Pill title="Tip" colour="YELLOW" />
                            <span className="ml-2 italic">
                                Make sure your sheets have restricted access set in sharing settings to prevent anyone
                                with the link accessing them. Paying customers will automatically be added to the list
                                of people.
                            </span>
                        </div>
                        <div className="flex flex-col sm:flex-row space-x-2 space-y-2">
                            <div className="border rounded-xl p-8 flex items-center">
                                <img
                                    src="/images/gsheet-share-button.png"
                                    alt="Google Sheets Share Button"
                                    className="w-2/3 mx-auto"
                                />
                            </div>
                            <div className="border rounded-xl p-8">
                                <img
                                    src="/images/gsheet-share.png"
                                    alt="Google Sheets Share Settings showing restricted access"
                                />
                            </div>
                        </div>
                    </p>
                </SnippetContainerBox>
            </div>
            <Footer
                prev={{ href: ROUTES.GATED_CONTENT_EDIT, disabled: false, label: 'Configure' }}
                item={gatedContent}
                size="LARGE"
            />
        </>
    );
}
